const ErrorPage = () => (
    <div className="container mt-4 text-center">
        <h1 className="text-danger">Något gick riktigt tokigt!</h1>
    </div>
);

export default ErrorPage;
